import React from 'react';
import {Dimensions, ViewStyle} from 'react-native';

import Carousel from 'react-native-reanimated-carousel';

interface Props {
  data: any;
  renderItem: ({item}: any) => React.JSX.Element;
  containerWidth?: number;
  itemWidth?: number;
  height?: number;
  parallaxScrollingScale?: number;
  parallaxScrollingOffset?: number;
  style?: ViewStyle;
}

export function BannerCarousel({
  data,
  renderItem,
  containerWidth,
  itemWidth,
  height,
  parallaxScrollingScale = 0.95,
  parallaxScrollingOffset,
  style,
}: Props) {
  const windowWidth = Dimensions.get('window').width;
  const baseWidth = containerWidth ?? windowWidth;
  const resolvedItemWidth = Math.round(itemWidth ?? baseWidth * 0.95);
  const carouselHeight = height ?? baseWidth / 4.2;
  const resolvedParallaxOffset =
    parallaxScrollingOffset ?? baseWidth * 0.08;

  return (
    <Carousel
      data={data}
      renderItem={renderItem}
      width={resolvedItemWidth}
      height={carouselHeight}
      mode="parallax"
      modeConfig={{
        parallaxScrollingScale,
        parallaxScrollingOffset: resolvedParallaxOffset,
      }}
      style={[{justifyContent: 'center', width: baseWidth}, style]}
      autoPlay
      autoPlayInterval={3500}
      loop
      pagingEnabled
    />
  );
}
